import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { pageAttributesActions } from '../PlacementDetails/Edit/store/placementPageAttributes.redux';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import {
  selectExtensionModalProps,
  selectPreExtensionModalProps,
} from '../PlacementDetails/Edit/store/placementPageAttributes.selector';
import overrideOpts from './overrideOpts.json';

const useStyles = makeStyles()(theme => ({
  formStyle: {
    marginLeft: '40px',
    marginTop: '10px',
  },
}));

export const ExtensionOverrideButtons = ({ ...props }) => {
  const { classes } = useStyles();
  const formMethods = useForm({ defaultValues: { extensionOverride: 0 } });
  const pageModalProps = useSelector(selectPreExtensionModalProps);
  const { isNewExtension } = useSelector(selectExtensionModalProps);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { handleSubmit } = formMethods;

  const onSubmit = data => {
    if (!!pageModalProps['callbackFn']) {
      !data.extensionOverride && pageModalProps['callbackFn']();
      dispatch(pageAttributesActions.setExtensionOverride(data.extensionOverride));
    } else
      dispatch(
        pageAttributesActions.setExtensionModalProps({
          ...data,
          open: true,
          isNewExtension: true,
          title: `${t('Extension')} - ${props?.extensionStatus}`,
          extensionStatusId: props?.extensionStatusId,
          extensionStatus: props?.extensionStatus,
        }),
      );
    dispatch(
      pageAttributesActions.setPreExtensionModalProps({
        open: false,
      }),
    );
  };

  return (
    <FormProvider {...formMethods}>
      <form className={classes.formStyle} onSubmit={handleSubmit(onSubmit)}>
        <Grid item>
          <Controller
            name="extensionOverride"
            control={formMethods.control}
            render={({ field }) => (
              <CustomRadioGroup
                {...field}
                extensionStatusId={props.extensionStatusId}
                isNewExtension={pageModalProps['isNewExtension'] !== undefined ? pageModalProps['isNewExtension'] : isNewExtension}
              />
            )}
          />
        </Grid>
        <button id={props.formBtnAccessorId} type="submit" style={{ visibility: 'hidden' }} />
      </form>
    </FormProvider>
  );
};

const CustomRadioGroup = ({
  value: { extensionOverride: option },
  onChange,
  extensionStatusId,
  isNewExtension,
  ...props
}) => {
  const options = React.useMemo(
    () =>
      isNewExtension
        ? extensionStatusId === 5
          ? overrideOpts.set1
          : overrideOpts.set2
        : extensionStatusId === 5
        ? overrideOpts.set1
        : extensionStatusId === 3
        ? overrideOpts.set3
        : [6, 4, 9].includes(extensionStatusId)
        ? overrideOpts.set4
        : [],
    [extensionStatusId, isNewExtension],
  );

  return (
    <RadioGroup
      value={option}
      onChange={(e, val) => {
        onChange(parseInt(val));
      }}
    >
      {options.map(item => (
        <FormControlLabel key={item.label} control={<Radio />} {...item} />
      ))}
    </RadioGroup>
  );
};
